module.exports = __webpack_public_path__ + "assets/gatsby.94e5bfad.svg";